<!--

    DojinCollection.vue
    同人收藏本

-->


<template>
  <el-collapse-item title="同人收藏本" name="同人收藏本" style="border-bottom: 1px solid #CDCDCD;">
    <el-row type="flex" class="row-bg" justify="space-between">
      <el-col :sm="4" :xs="0">
      </el-col>
      <el-col >
        <el-form
          :model="agencyFormData"
          
        >
          <!---->
          <el-form-item label="同人收藏本类型" id="dojincollectionform">
            <el-row type="flex" class="row-bg">
              <el-col >
                <el-radio-group v-model="agencyFormData['同人收藏本类型']">
                  <el-radio-button label="图集" class="my-selection-button">图集</el-radio-button>
                  <el-radio-button label="漫画" class="my-selection-button">漫画</el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="纸张色彩">
            <el-row type="flex" class="row-bg">
              <el-col >
                <el-radio-group v-model="agencyFormData['色彩']">
                  <el-radio-button label="彩色" class="my-selection-button">彩色</el-radio-button>
                  <el-radio-button label="黑白" class="my-selection-button">黑白</el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="纸张尺寸">
            <el-row type="flex" class="row-bg">
              <el-col >
                <el-input v-model="agencyFormData['尺寸宽']" placeholder="宽 cm"></el-input>
              </el-col>
              <el-col >
                <el-input v-model="agencyFormData['尺寸长']" placeholder="长 cm"></el-input>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="外封纸张">
            <el-row type="flex" class="row-bg">
              <el-col >
                <el-input placeholder="填写纸张全称" v-model="agencyFormData['外封纸张名称']"></el-input>
              </el-col>
              <el-col >
                <el-input placeholder="克(g)" v-model="agencyFormData['外封纸张质量']"></el-input>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="扉页纸张">
            <el-row type="flex" class="row-bg">
              <el-col >
                <el-input placeholder="填写纸张全称" v-model="agencyFormData['内页扉页纸张名称']"></el-input>
              </el-col>
              <el-col >
                <el-input placeholder="克(g)" v-model="agencyFormData['内页扉页纸张质量']"></el-input>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="封面纸张">
            <el-row type="flex" class="row-bg">
              <el-col >
                <el-input placeholder="填写纸张全称" v-model="agencyFormData['封面纸张名称']"></el-input>
              </el-col>
              <el-col >
                <el-input placeholder="克(g)" v-model="agencyFormData['封面纸张质量']"></el-input>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="内页纸张">
            <el-row type="flex" class="row-bg">
              <el-col >
                <el-input placeholder="填写纸张全称" v-model="agencyFormData['内页纸张名称']"></el-input>
              </el-col>
              <el-col >
                <el-input placeholder="克(g)" v-model="agencyFormData['内页纸张质量']"></el-input>
              </el-col>
              <el-col :span="6" :offset="2">
                <!--<el-button type="primary" circle>&nbsp;?&nbsp;</el-button>-->
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="覆膜">
            <el-row type="flex" class="row-bg">
              <el-col :span="8" :offset="1">
                <el-radio-group v-model="agencyFormData['覆膜']">
                  <el-radio-button label="  是  " class="my-selection-button">是</el-radio-button>
                  <el-radio-button label="  否  " class="my-selection-button">否</el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="印刷本数" :inline="true">
            <el-row type="flex" class="row-bg">
              <el-col :span="8" :offset="1">
                <el-input-number
                  v-model="agencyFormData['数量']"
                  :min="1"
                  :max="10000"
                  label="请输入印刷本数"
                ></el-input-number>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="页数" :inline="true">
            <el-row type="flex" class="row-bg">
              <el-col :span="8" :offset="1">
                <el-input-number
                  v-model="agencyFormData['页数']"
                  :min="1"
                  :max="10000"
                  label="请输入印刷页数"
                ></el-input-number>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="工艺" :inline="true">
            <el-row type="flex" class="row-bg">
              <el-col :span="8" :offset="1">
                <el-select v-model="agencyFormData['工艺']" placeholder="请选择制作工艺">
                  <el-option
                    v-bind:key="tech.id"
                    v-bind:label="tech"
                    v-bind:value="tech"
                    v-for="tech in technology.all"
                    name="type"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="装订" :inline="true">
            <el-row type="flex" class="row-bg">
              <el-col :span="8" :offset="1">
                <el-input placeholder="装订方法/工艺" v-model="agencyFormData['装订']"></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item  >
            <el-row type="flex" class="row-bg">
              <el-col :span="24" :offset="1">
                <el-button v-on:click="addEvent()">提交</el-button>
                <el-button v-on:click="clear()">清空</el-button>&nbsp;&nbsp;
                <a href="#dojincollectionform">
                  <el-button>
                    返回同人收藏本顶部
                    <i class="el-icon-upload2 el-icon--right"></i>
                  </el-button>
                </a>
              </el-col>
            </el-row>
          </el-form-item>

          <!---->
        </el-form>
      </el-col>
      <el-col :sm="4" :xs="0">
      </el-col>
    </el-row>
  </el-collapse-item>
</template>


<script>
export default {
  data() {
    return {
      forcollapse: ['allsame'],
      product: {
        DojinCollection: false, //同人收藏本
        DojinPeripheral: false //同人周邊
      },
      getMap: "",

      technology: {
        type: [], //被选择的内容
        all: [
          "烫亮金",
          "烫哑金",
          "烫黑金",
          "烫银",
          "烫蓝金",
          "烫紫金",
          "镭射银",
          "模切",
          "镂空",
          "UV",
          "烫金+烫银",
          "感温变色",
          "磨砂UV",
          "压痕",
          "拉页",
          "刷金",
          "刷银",
          "其它"
        ]
      },
      total: 1,
      formActive: ["thePrintTableData", "1", "2"],
      agencyFormData: {
        title: "同人收藏本"
      },
      allData: {}
    };
  },
  name: "DojinCollection",
  /*props: {
    msg: String,
  }*/
  props: {},
  methods: {
    addEvent: function() {
      this.$root.add(this.agencyFormData);
    },
    clear: function() {
      this.agencyFormData = {
        title: "同人收藏本"
      };
    }
  }
};
/**
 *     printTableData: [
        {
          param: "封面纸张",
          normal: `	
            铜版纸（128/157/200/250/300g）
            亚粉纸（128/157/200/250/300g）
            英国白卡纸（128/215/300g）`,
          always: `星河纸（240g）
            超感纸=雅涂（128/157/300g）
            冰白珠光（250/300g）
            高阶映画（240g）`,
          notoften: `莱尼纹（300g）
            超白木纹（260g）超白彩石（250g）南海细沙（280g）
            创意纹（300g）石斑纸（230g）帆布纹（300g）
            伯爵纸（300g）白牛皮（250g）黄牛皮（250g）
            蒙肯纸（100g）大地纸（230g）`
        },
        {
          param: "黑白内页纸张",
          normal: `米白道林（80/100/120g）
            黄道林（80/100/120g）
            双胶纸（80/100/120g）`,
          always: `欧维斯（80/100/120g）`,
          notoften: ``
        },
        {
          param: "彩色内页纸张",
          normal: `铜版纸（128/157/200/250/300g）
            亚粉纸（128/157/200/250/300g）`,
          always: `超感纸（128/157/300g） 
            高阶映画（240g）`,
          notoften: ``
        },
        {
          param: "扉页纸张",
          normal: ` `,
          always: `硫酸纸（110g）`,
          notoften: `飘银（110/240g）
            飘金（110/240g）`
        },
        {
          param: "腰封外封等纸张",
          normal: ` `,
          always: `硫酸纸（110g）`,
          notoften: ` `
        }
      ],
 */
</script>

<style scoped>
.my-button {
  padding: 200;
}
</style>